<template>
    <div>
        <!-- <div id="loading" v-show="showLoading">
            <img src="../assets/loading.gif" alt="Loading...">
        </div> -->
        <div class="container">
            <h1 class="title">公告</h1>
            <div class="notify">
                <li>自2023年7月6日起，本站下线【AI问答】和【文案工具箱】相关功能</li>
                <li>添加站长微信，继续一起学习、探索人工智能应用</li>
                <li>有任何问题可添加客服微信进行咨询，有问必回 </li>
            </div>

            <!-- <p class="description">自2023年7月5日起，下线【AI问答】和【文案工具箱】相关功能</p>
            <p class="description">关注公众号【AI文本工具站】，一起学习、探讨人工智能知识</p> -->
            <!-- <div id="form" class="centerBox">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 50 }" :placeholder="placeholder"
                    v-model="content" id="input"
                    style="font-size: 16px; font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB','Microsoft YaHei','微软雅黑',Arial,sans-serif;"
                    maxlength="2048" show-word-limit>
                </el-input>
                <div style="height:10px;width: 100%; ">
                    <button class="cleanButton" @click="clean">🗑️ 清空</button>
                </div>
                <el-button type="primary" @click="chat" :loading="showLoading">提交</el-button>
            </div>
            <div id="resultBox" class="centerBox" v-show="markdownText">
                <div id="result" disabled="disabled">
                    <p>{{ markdownText }}</p>
                </div>
                <el-button @click="copy">一键复制</el-button>
            </div> -->
        </div>
        <div class="ad ">
            <img :src="src" style="width:200px;" />

            <!-- <div class="centerBox">
                <el-carousel direction="vertical" :interval=5000>
                    <el-carousel-item v-for="(item, index) in ad" :key="'banner' + index">
                    </el-carousel-item>
                </el-carousel>
            </div> -->
        </div>

        <div>
            <!-- 其他代码 -->
            <el-dialog title="提示" :visible.sync="showDialog" width="30%">
                <span>即将跳转到【智能文本】...</span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { StreamAPI } from '../api/stream'


export default {
    name: 'Home',
    data() {
        return {
            placeholder: '在此处输入您想问的问题，尽可能多的提供信息，有助于GPT准确地回答你的问题。',
            content: '',
            showLoading: false,
            markdownText: '',
            src: require('../assets/images/aaron_plus_wx.jpg'),
            ad: [
                // {
                //     src: require('../assets/images/ad/ad_new_model.jpg'),
                //     url: 'https://mp.weixin.qq.com/s/I6Q6HDYmGINAUVKb5MejzA'
                // },
                {
                    // src: require('../assets/images/ad/qrcode-white.jpg'),
                    src: require('../assets/images/aaron_plus_wx.jpg'),
                    url: '/contact'
                },
                // {
                //     src: require('../assets/images/ad/16k.jpg'),
                //     url: 'https://mp.weixin.qq.com/s/CMnm6SrOhGIBcsdYXDfJHw'
                // },
                // {
                //     src: require('../assets/images/ad/ad_myacc.jpg'),
                //     url: 'http://myacc.top'
                // },
                // {
                //     src: require('../assets/images/ad/ad_ele.jpg'),
                //     url: 'https://mp.weixin.qq.com/s/IU5-PnDEtTWkVfJ8hKucTQ'
                // }
            ],
            showDialog: false, // 控制弹框显示

        }
    },
    methods: {

        clickAd(url) {
            console.info(url)
            if (url.startsWith("http")) {
                window.open(url, '_blank');
            } else {
                this.$router.replace(url)
            }
        },
        showAndRedirect() {
            this.showDialog = true; // 显示弹框
            setTimeout(() => {
                window.location.href = 'https://smarttxt.cn'; // 跳转到指定URL
            }, 3000); // 3秒后跳转
        }

    },
    mounted() {
        this.showAndRedirect(); // 组件挂载后调用方法
    }
}
</script>

<style scoped>
body {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 100vh;
    background-color: #f2f2f2;
}

.container {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    border-radius: 10px;
    width: 800px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 0 auto;
    box-sizing: border-box;
}

.notify li {
    margin: 5px 0;
}

@media only screen and (max-width: 768px) {
    .container {
        max-width: 100%;
    }

    .ad {
        max-width: 100%;
    }

    .el-carousel {
        width: 100%;
        height: auto;
        max-height: 200px;
    }

    .el-carousel__container {
        width: 100%;
        height: auto;
        max-height: 200px;
    }
}

.title {
    font-size: 30px;
    font-weight: bold;
    margin: 0;
    margin-bottom: 10px;
    text-align: center;
}

.description {
    font-size: 18px;
    margin: 0;
}

.centerBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    width: 100%;
}

.cleanButton {
    float: right;
    margin-right: 5px;
    margin-top: 5px;
    height: 20px;
    background-color: #90939988;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.cleanButton:hover {
    background-color: #909399;
}


#result {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
    min-height: 2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-y: auto;
}

#result>p {
    padding: 0;
    margin: 0.8rem;
    line-height: 1.5;
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color: #606266;
}

#input>>>textarea {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;

}

/* 广告样式 start */
.ad {
    border-radius: 10px;
    width: 800px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 0 auto;
    margin-top: 10px;
    cursor: pointer;
}

.el-carousel {
    width: 100%;
    height: auto;
}

.el-carousel__container {
    width: 100%;
    height: auto;
}

.el-carousel__item {
    opacity: 0.85;
    margin: 0;
    height: auto;
}


/* 广告样式 end */
</style>


// WEBPACK FOOTER //
// src/components/Home.vue